import React, { useState } from "react";
import styles from "./login.module.css";
import FormFields from "../../components/Form";
import { useNavigate } from "react-router-dom";
import Button from "common/Button";
import Toast from "utils";
import useSignIn from 'react-auth-kit/hooks/useSignIn';
import { postData } from "utils/queries";

const LoginForm = () => {
  const navigate = useNavigate();
  const signIn = useSignIn();

  const [loginDetails, setLoginDetails] = useState({
    email: "",
    password: ""
  });

  // const getUTMParameters = () => {
  //   const urlParams = new URLSearchParams(window.location.search);
  //   return {
  //     utm_source: urlParams.get('utm_source') || 'unknown',
  //     utm_medium: urlParams.get('utm_medium') || 'unknown',
  //     utm_campaign: urlParams.get('utm_campaign') || 'unknown',
  //   };
  // };

  // useEffect(() => {
  //   if (window.klaviyo && loginDetails.email) {
  //     const utmParams = getUTMParameters();
  //     try{

  //       window.klaviyo.identify({
  //         email: "krish@gmail.com",
  //         utm_source: "facebook",
  //         utm_medium: "social",
  //         utm_campaign: utmParams.utm_campaign,
  //       });
  
  //       console.log('UTM parameters sent to Klaviyo:', utmParams);
  //     }catch(error){
  //       console.log('UTM parameters sent to Klaviyo Error:', error);
  //     }

  //   }
  // }, [loginDetails.email]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await postData(`auth/login`, {
        email: loginDetails?.email,
        password: loginDetails?.password,
        role: "admin"
      }, false);

      if (response?.data?.success) {
        signIn({
          auth: {
            token: response?.data?.token,
            type: 'Bearer',
            refresh: response?.data?.refreshToken
          },
          refresh: response?.data?.refreshToken,
          userState: {
            name: 'User',
            ...response.data
          }
        });
        Toast().Success("Successfully logged in");
        navigate("/home");
      }
      // else {
      //   Toast().Error("Invalid Credentials");
      // }
    } catch (error) {
      console.log("error is", error);
      Toast().Error(
        error?.response?.data?.message || 
        error?.response?.data?.errors?.[0]?.msg || 
        'An unexpected error occurred'
      );
    }
  };

  const handleChange = (label) => {
    return (e) => {
      setLoginDetails({ ...loginDetails, [label]: e.target.value });
    };
  };

  const Fields = [
    {
      label: "Email",
      id: "email",
      placeholder: "Enter Email",
      type: "email",
      value: loginDetails?.email,
      required: true,
      onChange: handleChange("email"),
    },
    {
      label: "Password",
      id: "password",
      placeholder: "Password",
      type: "password",
      value: loginDetails?.password,
      required: true,
      onChange: handleChange("password"),
    }
  ];

  const forgotPassword = () => {
    navigate("/forgot-password");
  };

  return (
    <div className={styles.container}>
      <h2 htmlFor="email" className={styles.signInLabel}>
        Sign in
      </h2>

      <div className={styles.formContainer}>
        <form onSubmit={handleSubmit}>
          <FormFields Fields={Fields}  />
          <div className={styles.forgotPassword} onClick={forgotPassword}>Reset password</div>
          <div className={styles.formGroup}>
            <Button label={"Sign In"} buttonOverrideStyle={styles.button_} />
          </div>
        </form>
        <div className={styles?.divider}></div>
        <div className={styles.signupContainer}>
          <div className={styles.signupRow}>
            <div className={styles.signUpInfo}>
              Don’t have a Flow account?
              <br />
              New to Flow!
            </div>
            <button className={styles.registerButton} onClick={() => navigate("/signup")}>Register</button>
          </div>
          
          <div className={styles.signupRow}>
            <div className={styles.signUpInfo}>
               Want to manage multiple admins?
            </div>
            <button className={styles.registerButton} onClick={() => navigate("/signup?role=super-admin")}>Become a Super Admin</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
